import config from "./WebIMConfig";
import websdk from 'easemob-websdk'
import { Toast } from "mint-ui";

// 初始化IM SDK
var WebIM = {};
WebIM = window.WebIM = websdk;
WebIM.config = config;
WebIM.conn = new WebIM.connection({
	appKey: WebIM.config.appkey,
	isHttpDNS: WebIM.config.isHttpDNS,
	isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
	https: WebIM.config.https,
	url: WebIM.config.xmppURL,
	apiUrl: WebIM.config.apiURL,
	isAutoLogin: true,
	heartBeatWait: WebIM.config.heartBeatWait,
	autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
	autoReconnectInterval: WebIM.config.autoReconnectInterval,
	isStropheLog: WebIM.config.isStropheLog,
	delivery: WebIM.config.delivery
});
if (!WebIM.conn.apiUrl) {
	WebIM.conn.apiUrl = WebIM.config.apiURL;
}

// 注册监听回调
WebIM.conn.listen({
	// 连接成功回调
	onOpened: function (message) {
		console.log('登陆成功')
	},
	// 连接关闭回调
	onClosed: function () {
	},
	// 收到文本消息
	onTextMessage: function (message) {
		if (message.ext.roomId) {
			const ext = message.ext;
			const msg = {
				typeBed: ext.typeBed.low,
				typeRoom: ext.typeRoom.low,
				houseId: ext.typeRoom.low,
				roomId: ext.roomId.low,
				roomTitle: ext.roomTitle,
				roomName: ext.roomName,
				imgUrl: ext.imgUrl,
				houseName: ext.houseName,
				fee: ext.fee.low,
				area: ext.area.low
			}
			Vue.$store.dispatch('onMessageUpdateMsgList', {
				mid: message.id,
				phone: message.from,
				time: message.time,
				type: 'room',
				msg,
				isRead: false
			})
		} else {
			Vue.$store.dispatch('onMessageUpdateMsgList', {
				mid: message.id,
				phone: message.from,
				time: message.time,
				type: 'text',
				msg: message.sourceMsg,
				isRead: false
			})
		}
		let unread = Vue.$store.state.chat.unread;
		unread++;
		Vue.$store.commit('updateUnRead', unread);
	},
	// 收到图片消息
	onPictureMessage: function (message) {
		Vue.$store.dispatch('onMessageUpdateMsgList', {
			mid: message.id,
			phone: message.from,
			time: message.time,
			type: 'image',
			msg: message.url,
			isRead: false
		})
		let unread = Vue.$store.state.chat.unread;
		unread++;
		Vue.$store.commit('updateUnRead', unread);
	},
	// 收到命令消息
	onCmdMessage: function (message) {
		console.log("onCmdMessage", message);
	},
	// 本机网络连接成功
	onOnline: function () {
		console.log("onOnline 网络已连接");
	},
	// 本机网络掉线
	onOffline: function () {
		console.log("onOffline 网络已断开");
	},
	// 失败回调
	onError: function (message) {
		console.log('errmessage', message)
		if (message.type == 0) {
			console.log('请输入账号密码')
		} else if (message.type == 28) {
			console.log("未登陆")
		} else if (JSON.parse(message.data.data).error_description == "user not found") {
			Toast("用户名不存在！")
		} else if (JSON.parse(message.data.data).error_description == "invalid password") {
			console.log('密码无效！')
		} else if (JSON.parse(message.data.data).error_description == "user not activated") {
			Toast("用户已被封禁！")
		} else if (message.type == "504") {
			Toast("消息撤回失败");
		}
	},
	// 收到消息送达服务器回执
	onReceivedMessage: function (message) {
		message.status = "sent";
	},
	// 收到消息送达客户端回执
	onDeliveredMessage: function (message) {
		console.log("onDeliveredMessage", message);
	},
	// 收到消息已读回执
	onReadMessage: function (message) {
		console.log("onReadMessage", message);
		message.status = "read";
	},
});

export default WebIM;



// WEBPACK FOOTER //
// ./src/utils/WebIM.js